import _extends from "@babel/runtime/helpers/extends";
import { COUNTRY_CODES } from '@wix/form-multiline-address';
import React, { useMemo } from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useConfig } from '../../../contexts/config-context';
import { useTranslation } from '../../../contexts/translation-context';
import { useAddressLabel } from '../../../hooks/use-address-label';
import { createOption } from '../../../ui/autocomplete/autocomplete-wut';
import { DropdownAutocompleteWUT } from '../../../ui/dropdown-autocomplete';
export const MlaCountryWUT = _ref => {
  let {
    options,
    onChange,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    language
  } = useConfig();
  const label = useAddressLabel('country');
  const fieldType = FIELD_TYPES.MLA_COUNTRY;
  const countryOptions = useMemo(() => (options || []).reduce((result, option) => {
    if (option.value && COUNTRY_CODES.hasOwnProperty(option.value)) {
      result.push(createOption({
        value: t(`locale-dataset.countries.${COUNTRY_CODES[option.value].toUpperCase()}`),
        id: option.value
      }));
    }
    return result;
  }, []).sort((a, b) => a.value.localeCompare(b.value, language)), [options, t, language]);
  return /*#__PURE__*/React.createElement(DropdownAutocompleteWUT, _extends({}, rest, {
    fieldType: fieldType,
    label: label,
    options: countryOptions,
    onChange: value => onChange(value)
  }));
};
//# sourceMappingURL=mla-country-wut.js.map